import { render } from "./InputChoice.vue?vue&type=template&id=215d2096"
import script from "./InputChoice.vue?vue&type=script&lang=js"
export * from "./InputChoice.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__